<template>
  <div>
     <b-button
      v-permission="'teachers.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      ref="grid"
      :service="service"
      route_name="teachers"
      order_column="name"
      :fetch-on-mounted="false">
      <template v-slot:filterZone>
        <LegalEntityFilter v-model="filters" @change="updateFilters" />
      </template>
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('teacher.name') }}</vs-th>
        <vs-th key="email" sort-key="email">{{ $t('teacher.email') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="30%" key="name">
            <div> {{ tr.teacher_name }}</div>
          </vs-td>
          <vs-td width="40%" key="email">
            <div v-html-safe="tr.teacher_email"></div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'teachers.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'teachers.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'

import Grid from '@/components/Grid.vue'
import LegalEntityFilter from '@/components/filters/LegalEntityFilter.vue'
import TeacherService from '@/services/api/TeacherService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    Grid,
    LegalEntityFilter
  },
  data: () => ({
    selected: [],
    service: null,
    filters: { legal_entity_id: null }
  }),
  computed: {
    ...mapGetters('dataAccess', ['entities', 'isSystemAdmin'])
  },
  methods: {
    addNew() {
      this.$router.push('/teachers/create')
    },
    updateFilters() {
      const grid = this.$refs.grid
      if (!grid) {
        return
      }

      grid.custom_filters = []

      // Usuário comum sem estabelecimento vinculado: nada a listar.
      if (!this.isSystemAdmin && this.entities.length === 0) {
        return
      }

      let legalEntityId = this.filters.legal_entity_id

      // Usuário comum com um único estabelecimento: filtro fixo nesse ID.
      if (!this.isSystemAdmin && this.entities.length === 1) {
        legalEntityId = this.entities[0].id
      }

      if (legalEntityId) {
        grid.fillCustomFilters([{ key: 'legal_entity_id', value: legalEntityId }])
      }

      grid.fetchGridData(true)
    }
  },
  beforeMount() {
    this.service = TeacherService.build(this.$vs)
  }
}
</script>
